module.exports = __webpack_public_path__ + "static/media/carticon.998c4eac.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/carticon.svg
// module id = 61
// module chunks = 0